import React, { useEffect, useState } from 'react';
import Navbar from '../layouts/navbar'
import Parse from 'parse';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';

const Forums = () => {
    const [forums, setForums] = useState([]);
    useEffect(() => {
        console.log("usefffect runn")
        const Forum = Parse.Object.extend("Forum");
        const query = new Parse.Query(Forum);
        query.find()
            .then((forums) => {
                // The object was retrieved successfully.
                console.log("then runnn")
                console.log(forums);
                // console.log(forums.id);
                setForums(forums.reverse());
            }, (error) => {
                swal("Oops!", "Seems like there is some problem with net...Please try again in sometime", "error");
                console.log(error);
                // The object was not retrieved successfully.
                // error is a Parse.Error with an error code and message.
            });

    }, []);
    return (
        <div>
            <Navbar head="Forum" />

            <div className="container" style={{ marginTop: "50px" }}>
                <Link to="/forumadd">
                    <button id="myBtn" className="p-1">
                        <i className="fas fa-plus-circle fa-3x"></i>
                        <p className="m-0 align-self-center ml-2">New Post</p>
                    </button>
                </Link>
                {forums.map(forum => {
                    // console.log(forum);
                    // console.log(forum.id);

                    let d = forum.createdAt;
                    return (
                        <div className="card my-3 shadow-sm" key={forum.id}>
                            <div className="p-2" style={{ borderLeft: "solid 3px #65cdf0" }}>

                                <span className="mr-2"><img src="/assests/images/user.png" height="40" alt="user"></img></span>

                                <p className="mb-0" style={{ color: "#65cdf0", fontSize: "1.25em" }}>
                                    {forum.get("user_id")}
                                </p>

                                <p className="text-secondary">
                                    {d.toLocaleDateString()}
                                </p>
                                {/* {console.log(forum.get("createdAt"))} */}
                                <Link to={`/forum/${forum.id}`}>
                                    <h4 className="mb-0" style={{ color: "#65cdf0" }} >
                                        {forum.get("question")}
                                    </h4>
                                </Link>

                                <div className="card-text">
                                    {forum.get("description")}
                                </div>

                            </div>
                        </div>
                    )
                })}

            </div>
        </div>
    )
}

export default Forums;